import apiClient from '../apiClient';
import { GET_CITY_BY_ID_URL } from '../apiUrl';

const getCityByIdApi = Id => {
  return apiClient.get(GET_CITY_BY_ID_URL(Id));
};

export default getCityByIdApi;
